import React, { useEffect, useRef, useState } from "react";

/* ===== BACKGROUNDS ===== */
import bg1 from "../../../images/LandingPageImage/campaign_bg.webp";
import bg2 from "../../../images/LandingPageImage/analytics_bg.webp";
import bg3 from "../../../images/LandingPageImage/template_creation_bg.webp";
import bg4 from "../../../images/LandingPageImage/chat_flow_bg.webp";
import google from "../../../images/LandingPageImage/google.png";
/* ===== CENTER IMAGES ===== */
import img1 from "../../../images/LandingPageImage/whatsapp_campaign.webp";
import img5 from "../../../images/LandingPageImage/audience_targeting.webp";
import img13 from "../../../images/LandingPageImage/template_creation.webp";
import img16 from "../../../images/LandingPageImage/chat_flow.webp";

import { useNavigate } from "react-router-dom";

// css
import "./SecondScroll.css";

const TEXT_SLIDES = [
  {
    id: 1,
    label: "Whatsapp Campaign",
    desc: "Our WhatsApp Campaign tool allows you to communicate your message to the right audience in a speedy manner! With just a few clicks, personalized messages, updates, and promotions can be sent directly to your customers in no time at all. It is very easy to create, organize, and keep track of your campaigns, grant feedback, and communicate all at once. The aim of this feature is to liberate your time and increase the engagement with your customers twofold, thus it is an extension of every interaction—an opportunity to grow the business with no hassle borne.",
  },
  {
    id: 2,
    label: "Audience Targeting",
    desc: "Unlock the power of precision with our Audience Targeting feature! Reach the right people at the right time by segmenting your contacts based on behavior, interests, or demographics. Send personalized WhatsApp messages that truly resonate, boost engagement, and drive conversions. Say goodbye to generic broadcasts and hello to smarter communication that turns every interaction into an opportunity for growth.",
  },
  {
    id: 3,
    label: "Personalized Messages",
    desc: "Make every conversation valuable through Personalized Messages! Make sending out WhatsApp messages to each customer a breeze by customizing them with messages that are human-like, relevant, and engaging. Increase replies, foster relationships, and make sales by addressing the needs of your audience. Our software takes care of your interactions, whether they are in the form of greetings, notifications, or even marketing without fail; personalized, up-to-date, and powerful messages will always be there to charm your audience.",
  },
  {
    id: 4,
    label: "Automated Replies",
    desc: "Automated Replies & Smart Flows allow your WhatsApp automation tool to respond to customer messages instantly, even outside business hours. Smart Flows guide conversations based on user inputs, helping customers find information, get support, or complete actions without manual intervention.",
  },
];

const BG_MAP = { 1: bg1, 2: bg2, 3: bg3, 4: bg4 };
const IMG_MAP = { 1: img1, 2: img5, 3: img13, 4: img16 };

const SecondScroll = ({ slides = TEXT_SLIDES }) => {
  const [activeId, setActiveId] = useState(slides[0]?.id || 1);
  const slideRefs = useRef([]);

  const navigate = useNavigate();

  const handleReadMore = (id) => {
    if (id === 1) navigate("/whatsapp-campaign");
    else if (id === 2) navigate("/audiance-targating");
    else if (id === 3) navigate("/personalized-message");
    else if (id === 4) navigate("/automated-replies");
  };

  /* ===== INTERSECTION OBSERVER ===== */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        let best = null;

        entries.forEach((entry) => {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });

        if (best && best.intersectionRatio > 0.35) {
          setActiveId(Number(best.target.dataset.id));
        }
      },
      {
        threshold: [0.25, 0.5, 0.75],
        rootMargin: "-20% 0px -20% 0px",
      }
    );

    slideRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="ss2-wrapper">
        <div className="ss2-container">
          {/* ===== DESKTOP STICKY IMAGE ===== */}
          <div className="ss2-left">
            <div
              className="ss2-image-card"
              style={{ backgroundImage: `url(${BG_MAP[activeId]})` }}
            >
              <div
                key={activeId}
                className={`ss2-animation-wrapper ${
                  activeId === 1
                    ? "from-left"
                    : activeId === 2
                    ? "from-right"
                    : activeId === 3
                    ? "from-bottom"
                    : "from-left"
                }`}
              >
                <img
                  src={IMG_MAP[activeId]}
                  alt=""
                  className="ss2-center-img"
                />
              </div>
            </div>
          </div>

          {/* ===== TEXT + MOBILE IMAGE ===== */}
          <div className="ss2-right">
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className="ss2-slide"
                data-id={slide.id}
                ref={(el) => (slideRefs.current[index] = el)}
              >
                <div>
                  <div className="ss2-label">{slide.label}</div>
                  <p className="ss2-desc">{slide.desc}</p>

                  <div className="ss2-btn-group">
                    <button
                      className="ss2-btn ss2-btn-outline"
                      onClick={() => handleReadMore(slide.id)}
                    >
                      Read More
                    </button>

                    <button
                      className="ss2-btn ss2-btn-primary"
                      onClick={() => navigate("/login?provider=google")}
                    >
                      <span>Continue with</span>
                      <img
                        src={google}
                        alt="Google"
                        style={{
                          width: "28px",
                          height: "28px",
                          marginLeft: "10px",
                        }}
                      />
                    </button>
                  </div>
                  <div
                    className="ss2-mobile-image-card"
                    style={{ backgroundImage: `url(${BG_MAP[slide.id]})` }}
                  >
                    <img
                      src={IMG_MAP[slide.id]}
                      alt={slide.label}
                      className="ss2-center-img from-bottom"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SecondScroll;
